export default __webpack_public_path__ + "static/media/Super market.76918d8e.jpg";